<script>
    import {GPContextFixedCutter} from "./gp-context-fixedcutter.js";
    import {getGPTransFunc} from "./gp-translations";
    import {somethingDrawn} from "./gp-context-fixedcutter.js";

    let trans = getGPTransFunc("gp-fixedcutter");

    let anyFixedObjects = false;


    function cutObject (){
        if ($somethingDrawn)
            GPContextFixedCutter.cutOffCustomObject();
        refreshButtons();
    }

    /**
     * enable/disable buttons depending on situation (something is already cut from background or not)
     */
    function refreshButtons() {
        anyFixedObjects = false;
        GP.project.items.forEach(function (value) {
            if (value.fixedObject) anyFixedObjects = true;
        });

    }

    /**
     * Removes all fixed objects from the project
     */
    function deleteObjects () {
        var toRemove = [];
        GP.project.items.forEach(function (value) {
            if (value.fixedObject) toRemove.push(value.id)
        });
        toRemove.forEach(value => GP.project.removeItem(value));
        refreshButtons();
    }

</script>

<div id="GPFixedCutter">
    <div>
        <p>
            <img src="img/fixedCutExample.png"/>
            {trans("Paint over the object on the background image, such as house or tree, that should be part of the final project")}.
            {trans("The app will then intelligently sort it among other project elements to create best perspective effect")}.
            <br/><br/>
            {trans("Do this object by object")}. {trans("Once an object is marked, press the button below")}.
        </p>
        <div class="GPFixedCutterActions">
            <button on:click={cutObject} id="GPFixedCutterConfirm" type="button" class="btn btn-default" class:disabled={$somethingDrawn===false}>{trans("Add object")}</button>
            <button on:click={deleteObjects} id="GPFixedCutterDelete" type="button" class="btn btn-outline" class:disabled={anyFixedObjects===false}>{trans("Reset objects")}</button>
        </div>
    </div>
</div>
